import { useState, useEffect } from "react";
import { useAppContext } from "../context/AppContext.jsx";
import "./style.css";
import Logo from "../../assets/LOGOTIPO1.png";
import SaldoCard from "../../componente/saldocard/SaldoCard.jsx";
import Despesas10Dias from "../../componente/despesa10dias/index.jsx";
import MetaCard from "../../componente/metas/index.jsx";
import DespesasCategoria from "../../componente/despesacategoria/index.jsx";
import Sidebar from "../../componente/sidebar/index.jsx";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";

function Principal() {
  const navigate = useNavigate();
  const { nome, codusuario } = useAppContext();
  const [mesSelecionado, setMesSelecionado] = useState(new Date());

  const [mostrarSaldo, setMostrarSaldo] = useState(true);
  const [sidebarAberto, setSidebarAberto] = useState(false);

  const [saldos, setSaldos] = useState([]);
  const [despesas10dias, setDespesas10dias] = useState([]);
  const [metas, setMetas] = useState([]);
  const [despesasCategoria, setDespesasCategoria] = useState([]);

  const [saldoGeral, setSaldoGeral] = useState(0);

  /* ================= BUSCAR SALDOS ================= */

  const fetchSaldos = async () => {
    try {
      const response = await api.get("v1/dashboard/listasaldos", {
        params: { codusuario }
      });
      const dados = response.data || [];
      setSaldos(dados);
      const total = dados.reduce(
        (acc, s) => acc + Number(s.saldoatual || 0),
        0
      );
      setSaldoGeral(total);
    } catch (error) {
      console.error("Erro ao buscar saldos:", error);
    }
  };

  /* ================= BUSCAR DESPESA 10 DIAS ================= */

  const fetchDespesas10Dias = async () => {
    try {
      const response = await api.get(
        "v1/dashboard/despesa10dias",
        {
          params: { codusuario }
        }
      );
      setDespesas10dias(response.data || []);
    } catch (error) {
      console.error("Erro ao buscar despesas:", error);
    }
  };

  /* ================= BUSCAR METAS ================= */

  const fetchMetas = async () => {
    try {
      const response = await api.get(
        "v1/dashboard/listametas",
        {
          params: { codusuario }
        }
      );
      setMetas(response.data || []);
    } catch (error) {
      console.error("Erro ao buscar metas:", error);
    }
  };

  /* ================= BUSCAR DESPESA POR CATEGORIA ================= */

  const mesAnterior = () => {
    const novaData = new Date(mesSelecionado);

    novaData.setMonth(
      novaData.getMonth() - 1
    );

    setMesSelecionado(novaData);
  };

  const proximoMes = () => {
    const novaData = new Date(mesSelecionado);

    novaData.setMonth(
      novaData.getMonth() + 1
    );

    setMesSelecionado(novaData);
  };

  const nomeMes =
    mesSelecionado.toLocaleDateString(
      "pt-BR",
      {
        month: "long",
        year: "numeric"
      }
    );

  const fetchDespesasCategoria = async () => {
    try {

      const mes = mesSelecionado.getMonth() + 1;
      const ano = mesSelecionado.getFullYear();

      const response = await api.get(
        "v1/dashboard/despesascategoria",
        {
          params: {
            codusuario,
            mes,
            ano
          }
        }
      );

      setDespesasCategoria(response.data || []);

    } catch (error) {
      console.error("Erro ao buscar despesas por categoria:", error);
    }
  };

  /* ================= USE EFFECT ================= */

  useEffect(() => {
    fetchSaldos();
    fetchDespesas10Dias();
    fetchMetas();
  }, []);

  useEffect(() => {
    fetchDespesasCategoria();
  }, [mesSelecionado]);

  /* ================= AVATAR ================= */

  const iniciais = nome
    ? nome
      .split(" ")
      .map(n => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase()
    : "US";

  const formatar = (v) =>
    v.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });

  return (
    <div className="principal-container">
      <Sidebar
        aberto={sidebarAberto}
        fechar={() => setSidebarAberto(false)}
      />

      <div className="principal-wrapper">
        {/* HEADER */}
        <div className="top-header">
          <div className="left-header">
            <img
              src={Logo}
              alt="Logo iContas"
              className="logo-img"
            />

            <div className="welcome-text">
              <span>Bem-vindo ao</span>
              <h2>iContas</h2>
            </div>
          </div>

          <div className="right-header">

            <div className="saldo-desktop">
              <div>
                <small>Saldo Geral</small>
                <h4>
                  {mostrarSaldo
                    ? formatar(saldoGeral)
                    : "••••••"}
                </h4>
              </div>

              <i
                className={`fa-solid ${mostrarSaldo ? "fa-eye-slash" : "fa-eye"
                  }`}
                onClick={() =>
                  setMostrarSaldo(!mostrarSaldo)
                }
              ></i>
            </div>

            <div
              className="user-avatar"
              onClick={() => setSidebarAberto(true)}
            >
              {iniciais}
            </div>

          </div>
        </div>

        {/* SALDO MOBILE */}
        <div className="mobile-only saldo-mobile">
          <small>Saldo Geral</small>

          <div className="saldo-mobile-row">
            <h3>
              {mostrarSaldo
                ? formatar(saldoGeral)
                : "••••••"}
            </h3>

            <i
              className={`fa-solid ${mostrarSaldo ? "fa-eye-slash" : "fa-eye"
                }`}
              onClick={() =>
                setMostrarSaldo(!mostrarSaldo)
              }
            ></i>
          </div>
        </div>

        {/* CONTENT */}

        <div className="principal-content">
          <div className="col-left">
            <div className="section-title">
              {saldos.length !== 0 && (<h5>Meus Saldos</h5>)}
            </div>

            {saldos.map((s) => (
              <SaldoCard
                key={s.codsaldo}
                dados={s}
              />
            ))}

            <div className="card">
              <h6>Despesas nos últimos 10 dias</h6>
              <Despesas10Dias dados={despesas10dias} />
            </div>

            <div className="section-title">
              <h5>Lista de Metas</h5>
            </div>

            {metas.map((m) => (
              <MetaCard
                key={m.codmeta}
                dados={m}
              />
            ))}
          </div>

          <div className="col-right">
            <div className="card">

              <div className="categoria-header">

                <h6>Despesas por Categoria</h6>

                <div className="mes-selector">

                  <button
                    onClick={mesAnterior}
                  >
                    <i className="fa-solid fa-chevron-left"></i>
                  </button>

                  <span>{nomeMes}</span>

                  <button
                    onClick={proximoMes}
                  >
                    <i className="fa-solid fa-chevron-right"></i>
                  </button>

                </div>

              </div>

              <DespesasCategoria
                dados={despesasCategoria}
              />

            </div>
          </div>
        </div>
      </div>

      {/* BOTÃO FLUTUANTE LANÇAMENTO */}
      <button
        className="fab-lancamento"
        onClick={() => navigate("/lancamento")}
      >
        <i className="fa-solid fa-plus"></i>
      </button>
    </div>
  );
}

export default Principal;